export default [
    {
        path: "/shipmap",
        name: "shipmap",
        component: () => import("@/views/Shipmap/tianMap.vue"),
    },
];
